import React, { useMemo, useContext, useState, useEffect } from "react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { Box, Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { AuthContext } from "../context";
import { MRT_Localization_IT } from "material-react-table/locales/it";

const GenericDynamicTable = (props) => {
	const {
		columns = [],
		data = [],
		renderDetailPanel, // Nuova prop per il dettaglio personalizzato
		pivotTable = false, // Flag per abilitare la modalità pivot
		authModelName,
		enableRowSelection = true,
		defualtGrouping = [],
		enableColumnFilterModes = true,
		rows,
		setRows,
		newLineButtonLabel = null,
		newLineButtonFontSize = "1.2rem",
	} = props;
	const authContext = useContext(AuthContext);

	const addNewRow = () => {
		const newRow = columnsWithActions.reduce((acc, column) => {
			if (column.accessorKey) {
				if (column?.typeOfValue === "boolean") {
					acc[column.accessorKey] = column.defaultValue || false;
				} else {
					acc[column.accessorKey] = ""; // Inizializza con valori vuoti}
				}
			}
			return acc;
		}, {});
		setRows((prevRows) => [...prevRows, newRow]);
	};

	const onDelete = React.useCallback((rowSelected) => {
		setRows((prevRows) => {
			const index = prevRows.findIndex((row) => row === rowSelected.original);
			if (index === -1) {
				return prevRows; // Nessuna modifica se la riga non viene trovata
			}
			return [...prevRows.slice(0, index), ...prevRows.slice(index + 1)];
		});
	}, []);

	// Aggiungi una colonna per il grouping se pivotTable è abilitato
	const columnsWithActions = useMemo(() => {
		const baseColumns = columns || [];
		const actionColumn = {
			id: "actions",
			header: "Cancella",
			Cell: ({ row }) => (
				<Box sx={{ display: "flex", gap: "8px" }}>
					<IconButton
						onClick={() => {
							if (
								window.confirm(
									"Sei sicuro di voler cancellare questa fase?\n Attenzione questa operazione è irreversibile."
								)
							)
								onDelete(row);
						}}
						size="medium"
						color={"error"}
					>
						<DeleteIcon />
					</IconButton>
				</Box>
			),
			size: 100,
		};

		return [...baseColumns, actionColumn];
	}, [columns, authContext, authModelName, pivotTable]);

	// Configurazione tabella
	const table = useMaterialReactTable({
		columns: columnsWithActions,
		data: rows,
		enableRowSelection: enableRowSelection,
		enableColumnFilterModes: enableColumnFilterModes,
		enableExpanding: pivotTable,
		enableGrouping: pivotTable,
		localization: MRT_Localization_IT,
		getSubRows: (row) => row.subRows,
		initialState: {
			showColumnFilters: true,
			grouping: defualtGrouping,
		},
		renderDetailPanel:
			pivotTable && props?.renderDetailPanel !== undefined
				? ({ row }) => renderDetailPanel(row.original) // Usa la funzione passata tramite props
				: undefined,
	});

	return (
		<div style={{ translate: "0 -5px" }}>
			<Button
				onClick={() => addNewRow()}
				sx={{
					marginBottom: "5px",
					background: "#000", // Sfondo nero
					color: "#fff!important", // Testo bianco
					fontSize: newLineButtonFontSize, // Dimensione del font più grande
					borderRadius: "16px", // Bordo rotondo
					"&:hover": {
						background: "#000", // Sfondo nero
						color: "#fff", // Testo bianco
					},
					"&:active": {
						background: "#000", // Sfondo nero
						color: "#fff", // Testo bianco
					},
					"&:focus": {
						background: "#000", // Sfondo nero anche quando è in focus
						color: "#fff", // Testo bianco in focus
						boxShadow: "none", // Rimuove l'ombra di focus (effetto blu predefinito)
					},
				}}
			>
				{newLineButtonLabel || "+"}
			</Button>

			<MaterialReactTable table={table} />
		</div>
	);
};

export default GenericDynamicTable;
